<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Grupos</span>
	  		    <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( grupos  , 'CURSOS_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

	  		    <v-btn
              color="orange"
              dark
              class="mr-2 text-capitalize"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
	  		  </v-card-title>
          
	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="6">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="grupos"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip 
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>
							  

							    <template v-slot:item.actions="{ item }">

							    	<v-btn 
							    		color="orange" 
							    		x-small
							    		icon
							    		@click="editItemAlumnos(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-account</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		icon
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-pencil</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="error" 
							    		x-small
							    		icon
							    		@click="deleteItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="blue" 
							    		x-small
							    		icon
							    		@click="alumnosAsistencia(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-clipboard-account</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idgrupos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>


            <v-col cols="12" md="6">
	          	<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="editedItem.idplanteles"
			          :items="planteles"
			          label="Selecciona un plantel"
			          hide-details
			          item-text="plantel"
			          item-value="id_plantel"
			        >
			        </v-autocomplete>
            </v-col>

           <v-col cols="12" md="6">
	          	<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="editedItem.idcursos"
			          :items="cursos"
			          label="Selecciona un curso"
			          hide-details
			          item-text="curso"
			          item-value="idcursos"
			        >
			        </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
	          	<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="editedItem.idhorarios"
			          :items="horarios"
			          label="Selecciona un horario"
			          hide-details
			          item-text="horario"
			          item-value="idhorarios"
			        >
			        </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
	          	<v-text-field
	          		v-model="editedItem.cupo"
	          		dense
	          		hide-details
	          		filled
	          		type="number"
	          		label="Cupo"
	          	>
	          	</v-text-field>
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12" md="6">
	          	<v-text-field
	          		v-model="editedItem.fechainicio"
	          		dense
	          		hide-details
	          		filled
	          		type="date"
	          		label="Fecha inicio"
	          	>
	          	</v-text-field>
            </v-col>

            <v-col cols="12" md="6">
	          	<v-text-field
	          		v-model="editedItem.fechafinal"
	          		dense
	          		hide-details
	          		filled
	          		type="date"
	          		label="fecha final"
	          	>
	          	</v-text-field>
            </v-col>

            <v-col cols="12" >
	          	<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="editedItem.idmaestros"
			          :items="teachers"
			          label="Selecciona un teacher"
			          hide-details
			          item-text="nomuser"
			          item-value="id"
			        >
			        </v-autocomplete>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="elevation-6"
            dark
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ver los alumnos -->
	  <v-dialog
      v-model="dialogAlumnos"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Editar alumnos grupos</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idgrupos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>

        	<v-row>
        		<v-col cols="12" md="8">
        			<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="alumno"
			          :items="alumnos"
			          label="Selecciona un alumno"
			          hide-details
			          return-object
			          item-text="nombre_completo"
			          item-value="idalumnos"
			        >
        				<template v-slot:append-outer>
		              <v-btn
		              	color="primary"
		              	@click="saveAlumno( )"
		              >
		              	<v-icon>mdi-plus</v-icon>
		              </v-btn>
		            </template>
        			</v-autocomplete>
        		</v-col>
        	</v-row>

          <v-row>
          	<v-col cols="12">
						  <v-data-table
						    :headers="headersAlumnos"
						    :items="inscritos"
						    class="elevation-0"
						    :mobile-breakpoint="100"
		            dense
						  >
						    <template v-slot:item.actions="{ item }">
						    	<v-btn 
						    		color="error" 
						    		x-small
						    		icon
						    		@click="deleteItemAlumnos(item)"
						    		class="mr-2"
						    	>
							      <v-icon small> mdi-delete</v-icon>
						    	</v-btn>
						    </template>

						    <template v-slot:item.estatus="{ item }">
						    	<v-switch
							      v-model="item.estatus"
							      color="green"
							      dense
							      @change="updateEstatusAlumnoGrupo( item )"
							    ></v-switch>
						    </template>

						    <template v-slot:no-data>
						      <v-btn
						        color="primary"
						        @click="initialize"
						        small
						      >
						        Actualizar
						      </v-btn>
						    </template>

						  </v-data-table>
  		    	</v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeAlumnos"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el grupo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDeleteAlumno" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el alumno del grupo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeAlumnos()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirmAlumno()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAlumnosAsistencia"
      max-width="1200px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Reporte de asistencia</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
        	<v-row>
        		<v-col cols="12" md="6" lg="4">
		          <v-text-field
		            v-model="fechainicio"
		            label="Fecha de inicio"
		            filled
		            type="date"
		          ></v-text-field>
        		</v-col>
        		<v-col cols="12" md="6" lg="4">
		          <v-text-field
		            v-model="fechafinal"
		            label="Fecha de final"
		            filled
		            type="date"
		          ></v-text-field>
        		</v-col>
        		<v-col cols="12" md="6" lg="4">
		          <v-btn @click="alumnosAsistencia( editedItem )">Consultar</v-btn>
        		</v-col>
        	</v-row>

        	<v-row>
        		<v-col cols="12">
        			<div>
						    <h2 class="text-xl font-bold mb-4">Reporte de Asistencias</h2>

						    <div v-for="semana in semanasUnicas" :key="semana" class="mb-8">
						      <h3 class="text-lg font-semibold mb-2">Semana {{ semana }}</h3>

						      <table class="w-full border border-gray-300 text-sm">
						        <thead class="bg-gray-100">
						          <tr>
						            <th class="border px-2 py-1">Alumno</th>
						            <th class="border px-2 py-1">Tutor</th>
						            <th class="border px-2 py-1">Tel. Alumno</th>
						            <th class="border px-2 py-1">Tel. Tutor</th>
						            <th class="border px-2 py-1">Folio</th>
						            <th v-for="dia in diasPorSemana[semana]" :key="dia" class="border px-2 py-1">
						              {{ dia }}
						            </th>
						          </tr>
						        </thead>
						        <tbody>
						          <tr v-for="alumno in alumnosPorSemana(semana)" :key="alumno.idalumnos">
						            <td class="border px-2 py-1">{{ alumno.nombre_alumno }}</td>
						            <td class="border px-2 py-1">{{ alumno.nombre_tutor }}</td>
						            <td class="border px-2 py-1">{{ alumno.telefono_alumno }}</td>
						            <td class="border px-2 py-1">{{ alumno.telefono_tutor }}</td>
						            <td class="border px-2 py-1">{{ alumno.semanas.find(s => s.semana === semana)?.folio || '-' }}</td>
						            <td
						              v-for="dia in diasPorSemana[semana]"
						              :key="dia"
						              class="border px-2 py-1 text-center"
						            >
						              {{
						                getValorAsistencia(alumno, semana, dia)
						              }}
						            </td>
						          </tr>
						        </tbody>
						      </table>
						    </div>
						  </div>
        		</v-col>
        	</v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            icon
            top
            absolute
            right
            @click="dialogAlumnosAsistencia = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

			  	<v-spacer></v-spacer>
			    <v-btn
			    	color="green"
	  				dark 
	  				block
	  				outlined
	  				@click="enviarAsistencias( editedItem )" 
	  			>
	  				<v-icon small left>mdi-content-save</v-icon>
	  				<span >Guardar</span>
	  			</v-btn>
			  </v-card-actions>


        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  import dayjs from 'dayjs'
	import isoWeek from 'dayjs/plugin/isoWeek'
	dayjs.extend(isoWeek)

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      defaultItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      cursos: [],

      headers: [
        { text: 'ID'         , value: 'idgrupos'       },
        { text: 'Plantel'    , value: 'plantel'        },
        { text: 'Curso'      , value: 'curso'          },
        { text: 'Horario'    , value: 'horario'        },
        { text: 'Inicia'     , value: 'fechainicio'    },
        { text: 'Termina'    , value: 'fechafinal'     },
        { text: 'Maestro'    , value: 'maestro'        },
        { text: 'Fecha Alta' , value: 'fecha_creacion' },
        { text: 'Actions'    , value: 'actions', sortable: false },
      ],

      headersAlumnos: [
        { text: 'ID'       , value: 'idgruposalumnos'  },
        { text: 'Alumno'   , value: 'alumno'           },
        { text: 'Teléfono' , value: 'telefono'         },
        { text: 'Edad'     , value: 'edad'             },
        { text: 'Estatus'  , value: 'estatus'          },
        { text: 'Correo'   , value: 'correo'           },
        { text: 'Actions'  , value: 'actions', sortable: false },
      ],



      cursos:[],
      horarios:[],
      planteles:[],
      alumnos:[],
      inscritos:[],
      teachers:[],
      dialogAlumnos:false,
      alumno: null,

      deleteAlumno: {
        idgruposalumnos:0,
        deleted: 0
      },

      listaalumnos:[],
      dialogDeleteAlumno: false,
      dialogAlumnosAsistencia: false,
      fecha_asistencia: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechainicio: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			fechafinal: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			menu: false,
      fechasHabiles:["2025-04-23"],
			fechaMin:null,
			fechaMax:null,
      headersAlumnosAsistencia: [
        { text: 'ID'         , value: 'idalumnos'          },
        { text: 'Plantel'    , value: 'nombre_alumno'      },
        { text: 'Curso'      , value: 'semana'             },
        { text: 'Horario'    , value: 'fecha'              },
        { text: 'Inicia'     , value: 'valor_asistencia'   },
        { text: 'Termina'    , value: 'folio'              },
        { text: 'Fecha Alta' , value: 'telefono_alumno'    },
        { text: 'Maestro'    , value: 'nombre_tutor'       },
        { text: 'Fecha Alta' , value: 'telefono_tutor'     },
      ],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar grupo' : 'Editar grupo'
      },

      semanasUnicas() {
	      const semanas = new Set()
	      this.listaalumnos.forEach(alumno => {
	        alumno.semanas.forEach(s => semanas.add(s.semana))
	      })
	      return Array.from(semanas).sort()
	    },
	    
	    diasPorSemana() {
	      const map = {}
	      this.semanasUnicas.forEach(semana => {
	        // Buscar la primera fecha que caiga en esa semana
	        const dias = []
	        let fecha = dayjs().startOf('year')
	        while (fecha.isoWeek() !== parseInt(semana)) {
	          fecha = fecha.add(1, 'day')
	        }
	        for (let i = 0; i < 7; i++) {
	          if (fecha.day() >= 1 && fecha.day() <= 5) {
	            dias.push(fecha.format('YYYY-MM-DD'))
	          }
	          fecha = fecha.add(1, 'day')
	        }
	        map[semana] = dias
	      })
	      return map
	    }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      dialogAlumnos ( val ){
      	val || this.closeAlumnos( )
      }

    },

    async created () {
      await this.initialize()
      await this.getCursos()
      await this.getPlanteles()
      await this.getHorarios()
      await this.getUsuarios()
      await this.getAlumnos()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.grupos = []
        return this.$http.get('grupos.list').then(response=>{
        	this.grupos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getCursos () {
      	this.cargar = true
        this.cursos = []
        return this.$http.get('cursos.list').then(response=>{
        	this.cursos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.list.erp').then(response=>{
        	this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getHorarios () {
      	this.cargar = true
        this.horarios = []
        return this.$http.get('horarios.list').then(response=>{
        	this.horarios = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios () {
      	this.cargar = true
        this.usuarios = []
        return this.$http.get('users').then(response=>{
        	this.usuarios = response.data
        	this.teachers = response.data.filter( el => el.idpuestos == 27 )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getAlumnos () {
      	this.cargar = true
        this.alumnos = []
        return this.$http.get('alumnos.list').then(response=>{
        	this.alumnos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      editItemAlumnos (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)

      	this.cargar = true
        this.inscritos = []

        return this.$http.get('grupos.alumnos/' + this.editedItem.idgrupos ).then(response=>{
        	this.inscritos = response.data
        	this.cargar      = false
        	this.dialogAlumnos = true
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })


      },

      deleteItem (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemAlumnos( item ){

        this.deleteAlumno = Object.assign({}, item)
        this.dialogDeleteAlumno = true

      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('grupos.update/' + this.editedItem.idgrupos, this.editedItem).then(response=>{
          this.validarSuccess( response.data.message )
          this.initialize () 
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      deleteItemConfirmAlumno () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.deleteAlumno.deleted = 1
        this.$http.put('grupos.alumnos/' + this.deleteAlumno.idgruposalumnos, this.deleteAlumno).then(response=>{
          this.validarSuccess( response.data.message )
          this.editItemAlumnos (this.editedItem) 
          this.dialogDeleteAlumno = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeAlumnos () {
        this.dialogAlumnos = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('grupos.update/' + this.editedItem.idgrupos, this.editedItem).then(response=>{
        		this.close()
          	this.validarSuccess( response.data.message )
          	this.initialize()
	        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('grupos.add', this.editedItem).then(response=>{
        		this.close()
          	this.initialize()
	        	this.cargar = false
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })
        }
      },

      saveAlumno() {
	      this.cargar = true
	      this.alumno.idgrupos = this.editedItem.idgrupos
        // Lo mandapos por el EP
        this.$http.post('grupos.alumnos', this.alumno).then(response=>{
      		this.alumno = null
        	this.editItemAlumnos( this.editedItem )
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })
      },

      alumnosAsistencia(item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)

        this.fechaMin = this.editedItem.fechainicio
				this.fechaMax = this.editedItem.fechafinal

      	this.cargar = true
        this.listaalumnos = []

        let payload = {
        	idgrupos   : this.editedItem.idgrupos,
        	fechafinal : this.fechafinal,
        	fechainicio: this.fechainicio,
        }


        return this.$http.post('reporte.alumnos.asistencia', payload ).then(response=>{
        	this.listaalumnos = response.data
        	this.cargar      = false
        	this.dialogAlumnosAsistencia = true
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })


      },

      updateEstatusAlumnoGrupo( value ){

      	return this.$http.post('update.estatus.grupoalumno', value ).then(response=>{

        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

      },

      alumnosPorSemana(semana) {
	      return this.listaalumnos.filter(alumno =>
	        alumno.semanas.some(s => s.semana === semana)
	      )
	    },
	    getValorAsistencia(alumno, semana, dia) {
	      const semanaData = alumno.semanas.find(s => s.semana === semana)
	      if (!semanaData) return '-'
	      const valor = semanaData.asistencias[dia]
	      if (valor === 1) return '✔️'
	      if (valor === 2) return '❌'
	      if (valor === 3) return '⏰'
	      return '-'
	    }

    },
  }
</script>



<style scoped>
	table {
	  border-collapse: collapse;
	}
</style>